module.exports = __webpack_public_path__ + "static/media/light-03.9e226131.jpg";